import { MenuId, MenuRegistry } from "../../actions/common/actions";
import { Command, CommandsRegistry, ICommandCanExecuteReturnValue, ICommandService } from "../../commands/common/commands";
import { ContextMenuContext, isContextMenuContext } from "../../contextview/common/context";
import { ServicesAccessor } from "../../instantiation/common/instantiation";
import { isPropertyLike } from "./properties";
import { SetPropertyCommand } from "./propertyCommands";



export class RefreshPropertyValueContextKeyCommand extends Command {

    static readonly ID = 'property.refreshPropertyValueContextKey';

    constructor() {
        super(RefreshPropertyValueContextKeyCommand.ID, 'Refresh Property Value');
    }

    canExecute(args: ContextMenuContext): ICommandCanExecuteReturnValue {
        if (isContextMenuContext(args)) {
            return {
                canExecute: true,
            }
        }
        return {
            canExecute: false,
        }
    }

    execute(_accessor: ServicesAccessor, args: unknown) {
        if (isContextMenuContext(args)) {
            const props = args.targets.filter(t => isPropertyLike(t));
            for (const prop of props) {
                prop.notifyChanged();
            }
        }
    }
}

export class ResetPropertyToDefaultCommand extends Command<ContextMenuContext, void | Promise<void>> {

    static readonly ID = 'property.resetToDefault';

    constructor() {
        super(ResetPropertyToDefaultCommand.ID, 'Reset Property to Default');
    }

    canExecute(args: ContextMenuContext): ICommandCanExecuteReturnValue {
        if (!isContextMenuContext(args)) return { canExecute: false };
        const properties = args.targets.filter(isPropertyLike);
        if (properties.length === 0) return { canExecute: false };
        return {
            canExecute: properties.every(property => property.editable && (property.resetToDefault !== undefined || property.metadata?.defaultValue !== undefined)),
        };
    }

    async execute(accessor: ServicesAccessor, args: ContextMenuContext): Promise<void> {
        if (!this.canExecute(args).canExecute) return;
        const commands = accessor.get(ICommandService);
        for (const property of args.targets.filter(isPropertyLike)) {
            if (property.resetToDefault) {
                await property.resetToDefault();
                continue;
            }
            await commands.executeCommand<SetPropertyCommand>(SetPropertyCommand.ID, {
                property,
                value: property.metadata.defaultValue,
            });
        }
    }
}


CommandsRegistry.registerCommand(new RefreshPropertyValueContextKeyCommand());
CommandsRegistry.registerCommand(new ResetPropertyToDefaultCommand());

MenuRegistry.appendMenuItem(MenuId.PropertyContext, {
    command: {
        id: ResetPropertyToDefaultCommand.ID,
        title: 'Reset to Default',
        icon: { id: "undo" },
        showWhenDisabled: true,
    },
    group: 'property',
    order: -110,
});

MenuRegistry.appendMenuItem(MenuId.PropertyContext, {
    command: {
        id: RefreshPropertyValueContextKeyCommand.ID,
        title: 'Refresh Value',
        icon: {
            id: "refresh"
        },
    },
    group: 'property',
    order: -100,
})
